var map = {
	"./avatar.svg": 66,
	"./behance.svg": 169,
	"./cesilogo.svg": 170,
	"./dribbble.svg": 171,
	"./email.svg": 73,
	"./eye.svg": 172,
	"./facebook.svg": 98,
	"./forbidden.svg": 173,
	"./github.svg": 174,
	"./link.svg": 175,
	"./linkedin.svg": 176,
	"./location.svg": 71,
	"./methodologies/api.svg": 99,
	"./methodologies/architecture.svg": 100,
	"./methodologies/cicd.svg": 101,
	"./methodologies/database.svg": 102,
	"./methodologies/design.svg": 103,
	"./methodologies/docker.svg": 104,
	"./methodologies/function.svg": 105,
	"./methodologies/git.svg": 106,
	"./methodologies/interface.svg": 107,
	"./methodologies/mobile.svg": 108,
	"./methodologies/prototype.svg": 109,
	"./methodologies/wireframe.svg": 110,
	"./phone.svg": 72,
	"./position.svg": 70,
	"./projects/links/design.svg": 111,
	"./projects/links/github.svg": 112,
	"./projects/links/live.svg": 113,
	"./projects/links/video.svg": 114,
	"./projects/technologies/adobexd.svg": 115,
	"./projects/technologies/android.svg": 116,
	"./projects/technologies/arduino.svg": 117,
	"./projects/technologies/bootstrap.svg": 118,
	"./projects/technologies/cicd.svg": 119,
	"./projects/technologies/docker.svg": 120,
	"./projects/technologies/firebase.svg": 121,
	"./projects/technologies/github.svg": 122,
	"./projects/technologies/java.svg": 123,
	"./projects/technologies/javascript.svg": 124,
	"./projects/technologies/kotlin.svg": 125,
	"./projects/technologies/laravel.svg": 126,
	"./projects/technologies/maps.svg": 127,
	"./projects/technologies/maths.svg": 128,
	"./projects/technologies/mongodb.svg": 129,
	"./projects/technologies/mysql.svg": 130,
	"./projects/technologies/nodejs.svg": 131,
	"./projects/technologies/react.svg": 132,
	"./projects/technologies/redux.svg": 133,
	"./projects/technologies/symfony.svg": 134,
	"./projects/technologies/vuejs.svg": 135,
	"./skills/attr/acs.svg": 45,
	"./skills/attr/atn.svg": 46,
	"./skills/attr/ci.svg": 47,
	"./skills/attr/cm.svg": 48,
	"./skills/attr/ctv.svg": 49,
	"./skills/attr/docker.svg": 50,
	"./skills/attr/gd.svg": 51,
	"./skills/attr/git.svg": 52,
	"./skills/attr/js.svg": 53,
	"./skills/attr/jsx.svg": 54,
	"./skills/attr/kt.svg": 55,
	"./skills/attr/md.svg": 56,
	"./skills/attr/node.svg": 57,
	"./skills/attr/sms.svg": 58,
	"./skills/attr/soi.svg": 59,
	"./skills/attr/st.svg": 60,
	"./skills/attr/tw.svg": 61,
	"./skills/attr/uixd.svg": 62,
	"./skills/attr/ve.svg": 63,
	"./skills/attr/wd.svg": 64,
	"./skills/human.svg": 95,
	"./skills/tech.svg": 96,
	"./skills/technical.svg": 97,
	"./walimlogo-light.svg": 74,
	"./walimlogo.svg": 75,
	"./youtube.svg": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;